import { CSSProperties } from 'react';

export const useComponentStyles = (): Record<string, CSSProperties> => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  expandedView: {
    position: 'absolute',
    top: '100%',
    right: '0',
    marginTop: '8px',
    backgroundColor: 'var(--color-surface)',
    border: '1px solid var(--color-border)',
    borderColor: 'var(--color-border)',
    borderRadius: '8px',
    padding: '16px',
    minWidth: '300px',
    zIndex: 1000,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  title: {
    fontWeight: 500,
    margin: 0,
    color: 'var(--color-text)',
  },
  addButton: {
    background: 'var(--color-surface-muted)',
    border: '1px solid var(--color-border)',
    cursor: 'pointer',
    padding: '6px',
    borderRadius: '4px',
    color: 'var(--color-text)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    color: 'var(--color-text-muted)',
  },
  engineList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  engineItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    padding: '8px',
    backgroundColor: 'var(--color-surface-muted)',
    borderRadius: '6px',
    border: '1px solid var(--color-border)',
    borderColor: 'var(--color-border)',
  },
  engineInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  engineName: {
    fontSize: '14px',
    fontWeight: 500,
    margin: 0,
    color: 'var(--color-text)',
  },
  engineStatus: {
    fontSize: '12px',
    color: 'var(--color-text-muted)',
    margin: 0,
  },
  alert: {
    display: 'flex',
    gap: '8px',
    padding: '8px',
    borderRadius: '6px',
    marginTop: '8px',
    fontSize: '13px',
    alignItems: 'flex-start',
  },
  warningAlert: {
    backgroundColor: 'var(--color-surface)7ed',
    color: '#9a3412',
    border: '#ffedd5',
  },
  errorAlert: {
    backgroundColor: '#fee2e2',
    color: '#b91c1c',
    border: '1px solid #fecaca',
    borderColor: '#fecaca',
  },
  // The header status chip itself now lives in header-status.module.scss —
  // one shared height/radius/type scale for the whole status row. What remains
  // here styles the expanded popover only.
  chevronColor: {
    color: 'var(--color-text, #374151) !important',
  },
  upgradeSection: {
    marginTop: '12px',
    padding: '12px',
    backgroundColor: '#f0fdf4',
    border: '1px solid #dcfce7',
    borderColor: '#dcfce7',
    borderRadius: '6px',
    //color: '#166534',
    color: '#166534',
  },
  upgradeTitle: {
    fontSize: '14px',
    fontWeight: 600,
    //color: '#166534',
    color: '#166534',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  featureList: {
    fontSize: '13px',
    color: '#166534',
    marginBottom: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  featureItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '6px',
  },
  checkIcon: {
    width: '14px',
    height: '14px',
    color: 'currentColor',
    marginTop: '2px',
    flexShrink: 0,
    flexGrow: 0,
  },
  upgradeButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    //backgroundColor: '#166534',
    backgroundColor: '#166534',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 12px',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer',
    width: '100%',
    justifyContent: 'center',
  },
  browserOption: {
    backgroundColor: '#f0f9ff',
    padding: '16px',
    borderRadius: '6px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    color: '#0369a1',
  },
  optionTitle: {
    fontSize: '14px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    //color: '#0369a1',
    color: '#0369a1',
  },
  browserButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    //backgroundColor: '#0369a1',
    backgroundColor: '#0369a1',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 12px',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer',
    width: '100%',
    justifyContent: 'center',
  },
  divider: {
    textAlign: 'center',
    color: 'var(--color-text-muted)',
    fontSize: '14px',
    position: 'relative',
    padding: '8px 0',
  },
  dividerLine: {
    borderTop: '1px solid var(--color-border)',
    borderColor: 'var(--color-border)',
    position: 'absolute',
    top: '50%',
    width: '100%',
    zIndex: 0,
  },
  dividerText: {
    backgroundColor: 'var(--color-surface)',
    padding: '0 12px',
    position: 'relative',
    zIndex: 1,
  },
  notifierConnected: {
    backgroundColor: 'var(--color-surface-muted)',
    borderColor: 'var(--color-border)',
    color: 'var(--status-success)',
  },
  notifierDisconnected: {
    backgroundColor: 'var(--color-surface-muted)',
    borderColor: 'var(--color-border)',
    color: 'var(--status-error)',
  },
});